import angular from 'angular';
import RecentActivityComponent from './recent.activity.component';
export default angular.module('invision.customercare.recentActivity', []).component('recentActivity', RecentActivityComponent).name;